import { render, staticRenderFns } from "./InspectionIssueBadgeLevelBox.vue?vue&type=template&id=34190904&scoped=true"
import script from "./InspectionIssueBadgeLevelBox.vue?vue&type=script&setup=true&lang=js"
export * from "./InspectionIssueBadgeLevelBox.vue?vue&type=script&setup=true&lang=js"
import style0 from "./InspectionIssueBadgeLevelBox.vue?vue&type=style&index=0&id=34190904&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../account/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "34190904",
  null
  
)

export default component.exports